import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class TitleService {
  private titleMeta = inject(Title);


  title = '';

  set(title = '', append = true): void {
    const brand = title.length <= 35 ? ' | Irish Celtic Jewellery' : ' | ICJ';
    this.titleMeta.setTitle(`${title}${append ? brand : ''}`);
    this.title = title;
  }
}
